import { render, staticRenderFns } from "./WechatAppModal.vue?vue&type=template&id=3e0805a0&"
import script from "./WechatAppModal.vue?vue&type=script&lang=js&"
export * from "./WechatAppModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports